import React from 'react';
import MediaQuery from 'react-responsive';
import { breakpoints } from '../../modules/constants';
import { TemplateImage } from '../../modules/templateImages';

import './preview.scss';

interface Props {
  desktop: TemplateImage;
  mobile: TemplateImage;
}

const Preview: React.FC<Props> = ({ desktop, mobile }: Props) => {
  return (
    <MediaQuery query={`(min-width: ${breakpoints.mobileLarge})`}>
      <div className="preview-component">
        <div className="preview-component__desktop-device">
          <img
            className="preview-component__desktop-img"
            src={desktop.large}
            alt=""
          />
        </div>
        <div className="preview-component__mobile-device">
          <img
            className="preview-component__mobile-img"
            src={mobile.small}
            alt=""
          />
        </div>
      </div>
    </MediaQuery>
  );
};

export default Preview;
